import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from 'src/app/core/auth.service';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent {

  form!: FormGroup;

  email: string = '';
  password: string = '';

  isLoading: boolean = false;
  messageType: undefined | 'error' | 'info';
  message: string = '';
  messageAction: string = '';
  emailNotConfirmed: boolean = false;
  wrongCredentials: boolean = false;
  confirmationMailSent: boolean = false;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
    if(this.userService.isLoggedIn.getValue()) {
      this.router.navigate(['/home']);
    }
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }

  submit() {
    this.form!.markAllAsTouched();
    if (!this.form!.valid) {
      return;
    }
    this.isLoading = true;
    this.authService.login(this.email, this.password).pipe(
      catchError(error => {
        this.wrongCredentials = true;
        this.isLoading = false;
        return throwError(error);
      })
    ).subscribe(result => {
      if (result.resendLink) {
        this.emailNotConfirmed = true;
      } else {
        if (!result.user.onboardingDone) {
          this.router.navigate(['onboarding']);
        } else {
          this.router.navigate(['/']);
        }
      }
      this.isLoading = false;
    });
  }

  resendConfirmEmail() {
    this.authService.resendVerificationEmail(this.email).subscribe((result) => {
      this.messageType = 'info';
      this.message = result.message;
      this.messageAction = '';
      this.confirmationMailSent = true;
    })
  }
}
